import React from 'react'
import { Section } from '../../components/Section'
import { SectionContentVerticalCarousel } from '../../components/SectionContentVericalCarousel'

// Anchored so the hero's "Learn how Mara works" CTA can scroll here.
export const SectionContentInstanceMaraHowItWorks: React.FunctionComponent =
  () => (
    <Section
      backgroundColor="light-gray"
      padding={100}
      slug="how-it-works-for-businesses"
    >
      <SectionContentVerticalCarousel
        subheading="HOW IT WORKS"
        heading="How Mara works"
        steps={[
          {
            description:
              '__Post:__ Post a shift, schedule, or event. Mara collects the key requirements and constraints instantly.',
            screenshot: {
              publicId: 'screenshots/mara-hiw-1',
              alt: 'Mara how it works, step 1: post',
            },
          },
          {
            description:
              '__Match:__ Mara evaluates skills, reliability, ratings, and preferences—matching your needs to the best available professionals in seconds.',
            screenshot: {
              publicId: 'screenshots/mara-hiw-2',
              alt: 'Step 2: Mara analyzes criteria to find matches',
            },
          },
          {
            description:
              '__Fill:__ Best-fit professionals are confirmed and prioritized—so your shift is covered and service stays smooth.',
            screenshot: {
              publicId: 'screenshots/mara-hiw-3',
              alt: 'Mara step 3: fill',
            },
          },
        ]}
      />
    </Section>
  )
